// extracted by mini-css-extract-plugin
export default {"btn-results":"view-result-button_btn-results__Oykb-","active":"view-result-button_active__11MUP"};